export default function ContactSection() {
  return (
    <section id="contact" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[700px] mx-auto">
        <div className="text-center">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            联系投稿
          </h2>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            天堂影视欢迎影迷朋友们提供片源建议、投稿影评文章或反馈观影体验问题。
            你的每一条建议都将帮助我们为大家提供更好的观影服务。
          </p>
          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-2 px-5 py-3 rounded-xl bg-background-50 border border-background-200/70 cursor-pointer">
              <i className="ri-mail-line text-primary-500 text-lg"></i>
              <span className="text-sm text-foreground-700">service@ttys.com</span>
            </div>
            <div className="flex items-center gap-2 px-5 py-3 rounded-xl bg-background-50 border border-background-200/70 cursor-pointer">
              <i className="ri-wechat-line text-green-500 text-lg"></i>
              <span className="text-sm text-foreground-700">天堂影视官方</span>
            </div>
            <div className="flex items-center gap-2 px-5 py-3 rounded-xl bg-background-50 border border-background-200/70 cursor-pointer">
              <i className="ri-weibo-line text-red-500 text-lg"></i>
              <span className="text-sm text-foreground-700">@天堂影视</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}